import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import VersionRemarksModalUI from './VersionRemarksModalUI'

class VersionRemarksModalSF extends Component {
    constructor(props) {
        super(props)
        this.state = {
            successMsg: null,
            errorList: null,

            // form events
            submitted: false,
            // form field
            tag: '',
            tagError: null,
            remarks: '',
            remarksError: null,
        }
    }

    render() {
        return (
            <VersionRemarksModalUI
                context={this.props.context}
                errorList={this.state.errorList}
                successMsg={this.state.successMsg}
                setErrorList={this.setErrorList}
                // modes
                addRemarksMode={this.props.addRemarksMode}
                submitted={this.state.submitted}
                // event handlers
                onSubmit={this.onSubmit}
                onCancelClick={this.props.onAddRemarksCancel}
                selectedFileName={this.state.selectedFileName}
                selectedVersion={this.state.selectedVersion}
                // form fields
                tag={this.state.tag}
                ontagChange={(event) => this.setState({ tag: event.target.value })}
                tagError={this.state.tagError}
                settagError={(error) => { this.setState({ tagError: error }) }}
                remarks={this.state.remarks}
                onremarksChange={(event) => this.setState({ remarks: event.target.value })}
                remarksError={this.state.remarksError}
                setremarksError={(error) => { this.setState({ remarksError: error }) }}
            />
        )
    }

    componentDidMount() {
        let context = this.props.context
        Modal.setAppElement('body')
    }

    onSubmit = (event) => {
        event.preventDefault();
        const { selectedFileName, selectedVersion } = this.props;
        let submitted = this.state.submitted
        if (submitted)
            return
        this.setState({
            successMsg: null,
            errorList: [],
            submitted: true
        })

        // let fileName = event.currentTarget.getAttribute('data-object-id')
        // let version = event.currentTarget.getAttribute('data-version')
        const bucket = 'PUBLIC_FILES';
        const folderName = 'loan_document_ftl_templates';
        RestApiUtils.put(this.props.context,
            `/api/su/s3contents/buckets/${bucket}/folders/${folderName}/files/${selectedFileName}/versions/${selectedVersion}/remarks`,
            this.onSubmitCallback, {
            tag: this.state.tag,
            remarks: this.state.remarks,
        }
        )
    }

    onSubmitCallback = (response) => {
        let errorList = []
        response.errorList.forEach(error => {
            errorList.push(error.message)
        })

        this.setState({
            successMsg: response.success,
            errorList: errorList,
            submitted: false
        })

        if (response.errorList.length === 0) {
            setTimeout(() => {
                this.setState({
                    successMsg: null
                })
                this.props.onAddRemarksCancel()
                this.props.onRefreshClick()
            }, 2000)
        }
    }

    setErrorList = (errorList) => {
        this.setState({ errorList: errorList })
    }
}

export default withRouter(VersionRemarksModalSF)





